import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/registrant/")({
  beforeLoad: () => {
    throw redirect({
      to: "/registrant/dashboard",
    });
  },
  component: () => null,
});
